import { useEffect, useState } from "react"
import mainAxios from "../../services/mainAxios"
import { useAppContext } from "../../AppContext"

export const useOpenBanking = () =>{
  const [loading,setLoading] = useState(false)
  const [bankAccounts,setBankAccunts] = useState([])
  const {selectedCompany:[selectedCompany]} = useAppContext()

    const getBankAccounts = () => {
      setLoading(true)
      mainAxios.get(`/api/accounts/company/${selectedCompany}`)
      .then(res=>{
        console.log({res})
        setLoading(false)
        if(res.status==200){
          setBankAccunts(res.data)
        }
      })
      .catch(()=>{
        setLoading(false)
      })
    }

    useEffect(()=>{
      if(selectedCompany){
        getBankAccounts()
      }
    },[selectedCompany])

    return {getBankAccounts,loading,bankAccounts}
}